import { css } from 'styled-components';
import { VariantOfType } from '../../variants';
import { FormControlCss } from '../styles';

export const CssTextareaDefault = css`
  ${FormControlCss}
  display: block;
  width: 100%;
  padding: var(--form-control-padding);
  resize: vertical;
  min-height: 4em;
  cursor: pointer;
`;

export const textareaVariants = {
  default: CssTextareaDefault,
};

export type ITextareaVariants = VariantOfType<typeof textareaVariants>;
